import { initBotId } from 'botid/client/core'

if (
  !import.meta.env.SSR &&
  !import.meta.env.DEV &&
  import.meta.env.VITE_BOTID_PROTECT === 'true'
) {
  initBotId({
    protect: [
      {
        path: '/_rpc',
        method: 'POST'
      }
    ]
  })
}

/**
 * @param  {any} data
 * @return {Promise<any>}
 */
export async function post(data) {
  const resp = await fetch('/_rpc', {
    method: 'POST',
    body: JSON.stringify(data),
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json'
    }
  })

  return resp.ok ? await resp.json() : {}
}
